import React from "react";

// Define the attribute lists and order using backend keys
const outfieldAttributes = [
  { key: 'Crossing Score', label: 'Crossing' },
  { key: 'Dribbling Score', label: 'Dribbling' },
  { key: 'Finishing Score', label: 'Finishing' },
  { key: 'Creativity Score', label: 'Creativity' },
  { key: 'Buildup Passing Score', label: 'Passing' },
  { key: 'Aerial Ability Score', label: 'Aerial Ability' },
  { key: 'Defensive Awareness Score', label: 'Defensive Awareness' },
  { key: 'Ball Winning Score', label: 'Ball Winning' },
  { key: 'Penalties Score', label: 'Penalties' },
];

const gkAttributes = [
  { key: 'Goalkeeper Aggressiveness Score', label: 'Aggressiveness' },
  { key: 'Goalkeeper Passing Ability Score', label: 'Passing Ability' },
  { key: 'Goalkeeper Shot Stopping Score', label: 'Shot Stopping' },
];

// Map backend keys to display labels (optional, can use list above directly)
// const attributeLabels = {
//   crossing: "Crossing",
//   dribbling: "Dribbling",
//   // ... add all others if needed
// };

function PlayerStats({ props: stats, role }) { // Destructure props into stats and role
  // Handle empty state
  if (!stats || Object.keys(stats).length === 0) {
    return (
      <div className="empty-state">
        <p>No player attributes available.</p>
      </div>
    );
  }

  // Determine which list of attributes to display based on role
  const attributesToDisplay = role === 'GK' ? gkAttributes : outfieldAttributes;

  return (
    <div className="asd"> {/* Consider a more descriptive class name */} 
      <ul>
        {attributesToDisplay.map(({ key, label }) => {
          const value = stats[key]; // Now uses the correct backend key

          // Skip if attribute doesn't exist in data or isn't a number
          if (typeof value !== 'number') {
            // Optionally log a warning if an expected attribute is missing
            // console.warn(`Attribute "${key}" not found or not a number for player.`);
            return null;
          }

          return (
            <li key={key}>
              <h5 className="title">
                {label} {/* Use the label from our defined list */}
              </h5>
              {/* Apply styling based on value */}
              <span className={`score rang-${Math.floor(value / 20)}`}>
                {value}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export { PlayerStats };
